"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VoiceButton;
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _Mic = _interopRequireDefault(require("../icons/Mic"));
var _hooks = require("../hooks");
var _styles = require("@mui/styles");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)({
  micContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    transition: 'box-shadow 0.3s ease-in-out'
  },
  micIcon: {
    fontSize: 30,
    color: 'black'
  },
  listening: {
    animation: '$pulse 1.5s infinite'
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 5px #ff4081'
    },
    '50%': {
      boxShadow: '0 0 15px #ff4081, 0 0 25px #ff4081'
    },
    '100%': {
      boxShadow: '0 0 5px #ff4081'
    }
  }
});
function VoiceButton({
  iconProps,
  onClick,
  onTextChange,
  isHotKeyPressed,
  isAIChat,
  keyTip,
  setIsHotKeyPressed,
  onStopGenerating,
  onSendQuestion,
  ...rest
}) {
  const {
    isListening,
    startListening,
    stopListening,
    text,
    handleStopListening
  } = (0, _hooks.useVoice)();
  const [showToolTip, setShowToolTip] = (0, _react.useState)(false);
  const classes = useStyles();
  (0, _react.useEffect)(() => {
    if (isAIChat) {
      let timeout1, timeout2;
      timeout1 = setTimeout(() => {
        setShowToolTip(true);
        timeout2 = setTimeout(() => {
          setShowToolTip(false);
        }, 3000);
      }, 1000);
      return () => {
        clearTimeout(timeout1);
        clearTimeout(timeout2);
      };
    }
  }, [isAIChat]);
  (0, _hooks.useUpdateEffect)(() => {
    if (isHotKeyPressed) {
      startListening();
      setIsHotKeyPressed?.(false);
    }
    onTextChange(text);
    if (!isListening) {
      handleStopListening();
      onStopGenerating();
      onSendQuestion();
    }
  }, [isHotKeyPressed, text, isAIChat, isListening]);
  function handleClick(e) {
    onClick?.(e);
    if (isListening) handleStopListening();else startListening();
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    open: isListening || showToolTip,
    PopperProps: {
      sx: {
        pointerEvents: 'inherit'
      }
    },
    title: showToolTip ? `[${keyTip}] to activate` : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        children: "Listening..."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "warning",
        onClick: handleStopListening,
        children: "Stop"
      })]
    }),
    arrow: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      className: isListening ? classes.listening : '',
      onMouseDown: e => e.preventDefault(),
      onClick: handleClick,
      ...rest,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Mic.default, {
        ...iconProps
      })
    })
  });
}